export function uncapitalize(str: string) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
